module.exports = __webpack_public_path__ + "db108a12f2ba3ed83795a7dd72f0a158.svg";